/**
 * Возможные виды контента ячееек расписания
 */
export enum ScheduleCellKind {
  timeSlot = 'timeSlot',
  tvEvent = 'tvEvent',
}
